import {optionAction, overlayPanelAction} from "../../../../redux/store";
import {useDispatch, useSelector} from "react-redux";
import TitleWithArchiveCode from "../atom/TitleWithArchiveCode";


const HistoryHeader = () => {
  const dispatch = useDispatch();
  const closeMyDesignHistory = async () => {
    dispatch(overlayPanelAction.setIsOverlayPanelActive(false));
    dispatch(optionAction.setCurrentHeader(""));
  }
  const customerId = sessionStorage.getItem("userCode");

  return (
    <div className={"design-history-header"}>
      <div className={"design-history-inner"}>
        <TitleWithArchiveCode code={customerId}/>
      </div>
      <button type={"button"} onClick={closeMyDesignHistory}>Close Button</button>
    </div>
  )
}

export default HistoryHeader;
